import React from "react";
import ReactDOM from "react-dom/client";
import { RouterProvider } from "react-router-dom";
import { FunifierClientSetup } from "./lib/funifier-client";
import { StartMonitoring } from "./lib/monitoring";
import { PresetsProvider } from "./context/presets-provider";
import { HelmetProvider } from "react-helmet-async";
import router from "./routes";

import "./global.css";
import "./assets/fonts/index.scss";

const root = document.getElementById("root");
if (!root) throw new Error("Root element not found");

StartMonitoring();
FunifierClientSetup();

ReactDOM.createRoot(root).render(
  <React.StrictMode>
    <HelmetProvider>
      <PresetsProvider>
        <RouterProvider router={router} />
      </PresetsProvider>
    </HelmetProvider>
  </React.StrictMode>,
);
